<template>
 <DashBoardLayout :showNavbar=true :isSearch=false >
<div class="w100">
        <!-- order Details Section -->
        <div class="col-lg-11 col-md-11 col-sm-11 auto">
            <div class="row">
                <div class="col-xxl-4 col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="show-product-wrap product">
                        <div class="col-xl-11 bg_white col-lg-11 col-11 product-show-wrap auto sh3 mb-3 position-relative">
                            <div class="c-wrap position-relative p-3 p-summary">
                                <div class="w100">
                                    <h2 class="pc-name">#{{orderList.order_id}}</h2>
                                    <span class="packing-p">{{orderList.order_status}}</span>
                                    <span class="text-left pt-1 bill-amount">Bill Amount : &#8377; {{orderList.camount}}</span>
                                </div> <span class="date-app-wrap">{{orderList.date_of_order}}</span>
                                <!-- 	<div class="add-to-cart cta-atc-wrap">

<input type="hidden" class="product_id" value="11">

<button class="p-cta-btn">Re-Order</button>

</div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-11 auto col-sm-12">
                <table class="table-wrapper data_table bod bg_white">
                    <thead>
                        <tr class="heading-tab">
                            <th>Product Name</th>
                            <th>Price (&#8377;)</th>
                            <th class="center">QTY</th>
                            <th class="center">Sub Total(&#8377;)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="moreOrderDetails in moreOrderDetail" :loading="loading" :key="moreOrderDetails.product_id">
                            <td class="pl-2">{{moreOrderDetails.product_name}}</td>
                            <td class="center">{{moreOrderDetails.rate}}</td>
                            <td class="center">{{moreOrderDetails.qty}}</td>
                            <td class="center">{{moreOrderDetails.subtotal}}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
 </div>
   </DashBoardLayout>
</template>


<script>
import axios from "axios"
import ApiList from '../ApiList'
import globalMixins from '../globalMixins'
import DashBoardLayout from '../../layouts/DashboardLayout.vue'
export default {
    name: 'OrderDetails',
    mixins: [ApiList, globalMixins],
    components: {
        DashBoardLayout
    },
    data() {
        return {
            loading: false,
            newUrl: "",
            orderList: [],
            moreOrderDetail: [],
            order_id: 141,
            uriParam: '',
        }
    },
    // created() {
    //     this.$emit(`update:layout`, DashBoardLayout)
    // },
    mounted() {
        this.checkSession();
        this.loadData();
    },
    methods: {
        loadData() {
            this.findOrderId();
            this.orderDetail();
            this.moreOrderDetails();

            // alert(this.newUrl)

        },
        orderDetail() {
            this.newUrl = this.apis.apiUrl + this.apis.ordersUrl
            this.param = {
                params: {
                    order_id: this.order_id,
                    token: localStorage.token
                }
            }
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    console.log(response)
                    // this.orderList = []
                    this.orderList = response.data
                    console.log(response.data);
                })
        },
        moreOrderDetails() {

            this.newUrl = this.apis.apiUrl + this.apis.moreOrderDetailsUrl
            this.param = {
                params: {
                    order_id: this.order_id,
                    token: localStorage.token
                }
            }
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    console.log(response)
                    // this.orderList = []
                    this.moreOrderDetail = response.data
                    // console.log(respons  e.data); 
                })
        },
        findOrderId() {
            let uri = window.location.href.split('?');
            // console.log("aaa "+uri);
            if (uri[1] != undefined) {
                // uriParam = uri[2];
                this.order_id = uri[1];
                console.log(uri[2] + ' -- ' + this.order_id)
            }
            // alert(this.order_id)
        }
    }
}
</script>
